// rootReducer
import { combineReducers } from "redux";
import { packagesReducer } from "./packagesReducer";
import { technicalAreaReducer } from "./technicalAreaReducer";
import { departmentReducer } from "./departmentReducer";
import { projectReducer } from "./projectReducer";
import { indicatorReducer } from "./indicatorsReducer";
import { userReducer, usersReducer } from "./userReducer";
import { challengeReducer } from "./challengeReducer";
import { facilityReducer } from "./facilityReducer";
import { roleReducer } from "./roleReducer";
import { permissionReducer } from "./permissionReducer";
import { menuReducer } from "./menuReducer";
import { formReducer } from "../slice/formSlice";

export const rootReducer = combineReducers({
  packages: packagesReducer,
  indicators: indicatorReducer,
  user: userReducer,
  users: usersReducer,
  role: roleReducer,
  menu: menuReducer,
  permission: permissionReducer,
  technicalArea: technicalAreaReducer,
  department: departmentReducer,
  projects: projectReducer,
  challenges: challengeReducer,
  facilities: facilityReducer,
  form: formReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
